export default "__VITE_ASSET__DYVDiAse__"